export const USER_GUIDE_START_EVENT_NAME = "User Guide Start Clicked";
export const USER_GUIDE_RESTART_EVENT_NAME = "User Guide Restart Clicked";
export const UNLOCK_CERTIFICATION_EVENT_NAME = "Unlock Certification Clicked";
export const CERTIFICATE_DOWNLOAD_EVENT_NAME = "Download Certificate Clicked";
export const CERTIFICATE_GENERATED_EVENT_NAME = "Certificate Generated";

export const enum UserGuideStartLocation {
  MissionControl = "Mission Control",
  AssistantPanel = "Assistant Panel",
  Launchpad = "Launchpad",
}
